export type ToRef = (v: any) => object | undefined;

export function createKeyspace(toKey: (ref: ToRef) => (value: any) => string) {
  return toKey(idRef);
}

export const skey = createKeyspace((ref) => {
  const replacer = replaceComplex(ref);
  return (value: any) => JSON.stringify(value, replacer);
});

export function replaceComplex(ref: ToRef) {
  return function replacer(__key: string, value: any) {
    if (typeof value === 'object') {
      if (value === null) return value;
      if (Array.isArray(value)) return value;
      const proto = Object.getPrototypeOf(value);
      if (!proto || proto === Object.prototype) {
        // Sorted so that key order doesn't distinguish equal structures.
        return Object.fromEntries(
          Object.keys(value)
            .sort()
            .map((key) => [key, value[key]])
        );
      }
      return ref(value);
    }
    if (typeof value === 'bigint') {
      return String(value);
    }
    return value;
  };
}

let nextId = 0n;
const identified = new WeakMap<any, bigint>();
export function id(o: any) {
  const existing = identified.get(o);
  if (existing !== undefined) {
    return existing;
  }
  const newId = nextId;
  nextId += 1n;
  identified.set(o, newId);
  return newId;
}

function idRef(v: any): object | undefined {
  if (v !== null && typeof v === 'object') {
    return { '\0.id': id(v).toString(36) };
  }
  return undefined;
}
